import React from 'react';
import PropTypes from 'prop-types';

function StatusCell({ dataItem }) {
  const { status = 'N/A', statusIcon = 'fa-solid fa-circle', statusColor = '#ABBAC3' } = dataItem;

  return (
    <td>
      <span className="qmb-avatar--24--status-icon">
        <i className={`fa-lg ${statusIcon}`} style={{ color: statusColor }} />
      </span>

      <span style={{ marginLeft: '0.5rem' }}>{status}</span>
    </td>
  );
}

StatusCell.propTypes = {
  dataItem: PropTypes.shape({
    status: PropTypes.string,
    statusIcon: PropTypes.string,
    statusColor: PropTypes.string
  }).isRequired
};

export default StatusCell;
